<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Philatélie" />
            <PhiLatelie />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import PhiLatelie from '../Services/Philatelie'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'PhiLateliePage',
    components: {
        NavBar,
        PageTitle,
        PhiLatelie,
        FooterComp,
    }
}
</script>